export default "__VITE_ASSET__BuFBAXwa__"